<template>
  <div>
    <v-row no-gutters>
      <span class="textLight--text font-weight-medium text-h5 text-start">
        {{ $t("user.basicInfo") }}
      </span>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-card
          flat
          class="px-4 py-3"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <!-- {{ key.charAt(0).toUpperCase() + key.slice(1) }} -->
                    <span>{{ $t("user.gender") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-select
                      :readonly="!isEditCard1"
                      append-icon=""
                      hide-details
                      v-model="card1.gender"
                      :items="gender"
                      item-text="text"
                      item-value="value"
                      dense
                      class="rounded-md text-body-2 ma-0 hide-underline"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.dob") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-menu
                      :disabled="!isEditCard1"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                        rules="required"
                      >
                        <v-text-field
                          class="hide-underline"
                          hide-details
                          v-model="card1.dob"
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker
                        color="textLight"
                        v-model="date"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.email") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.email"
                      :isEdit="isEditCard1"
                      :validateRules="'required|email'"
                      ref="email"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.mobile") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.mobile"
                      :isEdit="isEditCard1"
                      :validateRules="'numeric|max:10'"
                      ref="mobile"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.civilIdOrPassport") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.civilIdOrPassport"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.bloodGroup") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.bloodGroup"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.nationality") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-autocomplete
                      :readonly="!isEditCard1"
                      append-icon=""
                      hide-details
                      v-model="card1.nationality"
                      :items="countries"
                      item-value="name"
                      item-text="name"
                      dense
                      class="rounded-md text-body-2 ma-0 hide-underline"
                    >
                      <template v-slot:item="{ item }">
                        <div class="d-flex justify-start">
                          {{ item.name }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.department") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.department"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.designation") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.designation"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>

                <!--<basic-info-loader v-if="loading" />
                  <v-row v-else>
                 <v-col
                cols="5"
                sm="4"
                xl="3"
                class="subtitle-1 textLight--text mouse-cursor"
              >
                <span>
                  {{ $t("user.company") }}
                </span>
              </v-col>
              <v-col
                cols="7"
                sm="8"
                xl="9"
                class="subtitle-1 textLight--text"
                style="opacity: 0.5"
              >
                <div>
                  &lt;!&ndash;
                  <div v-if="!isEditCard1">
                    {{
                      card1.company && card1.company.name
                        ? getLocalisedValue(card1.company.name)
                        : null
                    }}
                  </div>
                  &ndash;&gt;
                  <v-autocomplete
                    readonly
                    append-icon=""
                    hide-details
                    v-model="organizationID"
                    :items="organizations"
                    item-value="id"
                    :item-text="$vuetify.rtl ? 'ar' : 'en'"
                    dense
                    class="rounded-md text-body-2 ma-0 hide-underline"
                  />
                </div>
              </v-col> 
              </v-row>-->
              </v-col>
            </v-row>
          </div>

          <float-btn
            v-if="!loading && isEditable"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card
          flat
          class="px-4 py-3"
          :key="reRender"
          :class="!isEditCard2 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.linkedin") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.linkedin"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="linkedin"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.twitter") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.twitter"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="twitter"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.facebook") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.facebook"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="facebook"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.instagram") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.instagram"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="instagram"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <basic-info-loader v-if="loading" />
                <v-row v-else>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.coursera") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.coursera"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="coursera"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <float-btn
            v-if="!loading && isEditable"
            :isEdit="isEditCard2"
            @save="saveCard2Items"
            @edit="isEditCard2 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData2"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../core-module/components/ContentEditable2.vue";
import BasicInfoLoader from "./skeleton-loaders/BasicInfoLoader.vue";
import FloatBtn from "./FloatBtn.vue";

import { updateEmployee } from "../methods/updateEmployee";

import countryList from "../../core-module/assets/json/countryList.json";

export default {
  components: {
    FloatBtn,
    Editable2,
    BasicInfoLoader,
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        gender: "",
        dob: "",
        email: "",
        mobile: "",
        designation: "",
        civilIdOrPassport: "",
        bloodGroup: "",
        nationality: "",
        department: "",
        // company: "",
      },
      card1Error: {
        email: null,
        mobile: null,
      },
      card2: {
        linkedin: "",
        twitter: "",
        facebook: "",
        instagram: "",
        coursera: "",
      },
      card2Error: {
        linkedin: null,
        twitter: null,
        facebook: null,
        instagram: null,
        coursera: null,
      },
      organizationID: "",
      organizations: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      gender: [
        { text: "Male", value: "MALE" },
        { text: "Female", value: "FEMALE" },
        { text: "Other", value: "OTHER" },
      ],
      loading: true,
      savingData1: false,
      savingData2: false,
      userProfile: null,
      isEditCard1: false,
      isEditCard2: false,
      reRender: 0,
      countries: countryList,
    };
  },

  computed: {
    isEditable() {
      return this.$route.name === "Profile";
    },
    isPublicProfile() {
      return this.$route.name === "PublicProfile";
    },
    getProfileVariables() {
      return {
        id: this.isPublicProfile ? this.$route.params.id : undefined,
      };
    },
  },
  apollo: {
    getProfile() {
      return {
        query: require("../api/query/getProfile.gql"),
        variables: this.getProfileVariables,
        result({ data, loading }) {
          if (data && data.getProfile) {
            this.userProfile = data.getProfile;
            this.resetFormData();
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    date(val) {
      this.card1.dob = this.formatDate(this.date);
    },
    isPublicProfile() {
      this.refetchGetProfile();
    },
  },
  methods: {
    refetchGetProfile() {
      this.loading = true;
      this.userProfile = null;
      this.resetFormData();
      this.$apollo.queries.getProfile.refetch(this.getProfileVariables);
    },
    resetFormData() {
      const roleKey = this.userProfile?.role?.toLowerCase();

      this.card1.gender = this.userProfile?.[roleKey]?.gender;
      this.card1.dob = this.userProfile?.[roleKey]?.dob
        ? this.$moment(parseInt(this.userProfile?.[roleKey]?.dob)).format(
            "DD/MM/YYYY"
          )
        : null;
      this.card1.email = this.userProfile?.email;
      this.card1.mobile = this.userProfile?.phone?.number;
      this.card1.designation = this.userProfile?.[roleKey]?.designation;
      this.card1.civilIdOrPassport = this.userProfile?.civilIdOrPassport;
      this.card1.bloodGroup = this.userProfile?.[roleKey]?.bloodGroup;
      this.card1.nationality = this.userProfile?.[roleKey]?.nationality;
      this.card1.department = this.userProfile?.[roleKey]?.department;
      // this.organizationID = this.userProfile?.[roleKey]?.organization?._id;

      // this.setCompanyValue();

      this.card2.linkedin =
        this.userProfile?.[roleKey]?.externalLinks?.linkedin;
      this.card2.twitter = this.userProfile?.[roleKey]?.externalLinks?.twitter;
      this.card2.facebook =
        this.userProfile?.[roleKey]?.externalLinks?.facebook;
      this.card2.instagram =
        this.userProfile?.[roleKey]?.externalLinks?.instagram;
      this.card2.coursera =
        this.userProfile?.[roleKey]?.externalLinks?.coursera;

      this.reRender++;
    },
    resetCard1Error() {
      this.card1Error = {
        email: null,
        mobile: null,
      };
    },
    resetCard2Error() {
      this.card2Error = {
        linkedin: null,
        twitter: null,
        facebook: null,
        instagram: null,
        coursera: null,
      };
    },
    // async setCompanyValue() {
    //   this.organizations = await this.$apollo
    //     .query({
    //       query: require("@/app/user-module/api/query/getOrganizations.gql"),
    //       variables: {
    //         limit: 0,
    //         skip: 0,
    //       },
    //     })
    //     .then(result => {
    //       if (
    //         result &&
    //         result.data &&
    //         result.data.getOrganizations &&
    //         result.data.getOrganizations.organizations
    //       ) {
    //         this.card1.company =
    //           result.data.getOrganizations.organizations.find(
    //             obj => obj._id === this.organizationID
    //           );
    //         return result.data.getOrganizations.organizations.map(obj => {
    //           let organization = {};
    //           organization.id = obj._id;
    //           obj.name.map(val => {
    //             organization[val.lang] = val.value;
    //           });
    //           return organization;
    //         });
    //       }
    //     });
    // },
    async saveCard1Items() {
      this.resetCard1Error();
      this.snackbarErrorMessage = null;

      this.card1Error.email = (await this.$refs.email.checkIsValid())
        ? null
        : true;

      this.card1Error.mobile = (await this.$refs.mobile.checkIsValid())
        ? null
        : true;

      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }

      this.savingData1 = true;
      this.isEditCard1 = false;

      let saveData = {
        dob: this.card1.dob ? this.formatDateServer(this.card1.dob) : null,
        gender: this.card1.gender ? this.card1.gender : null,
        designation: this.card1.designation,
        bloodGroup: this.card1.bloodGroup ? this.card1.bloodGroup : "",
        nationality: this.card1.nationality ? this.card1.nationality : "",
        department: this.card1.department ? this.card1.department : "",
        user: {
          email: this.card1.email ? this.card1.email : null,
          civilIdOrPassport: this.card1.civilIdOrPassport
            ? this.card1.civilIdOrPassport
            : null,
          phone: {
            countryCode: "+965",
            number: this.card1.mobile ? this.card1.mobile : "",
          },
        },
      };
      this.card2Error.linkedin = (await this.$refs.linkedin.checkIsValid())
        ? null
        : true;

      // if (this.userProfile.role === "EMPLOYEE") {
      //   saveData.organization = this.organizationID
      //     ? this.organizationID
      //     : null;
      // }

      this.update(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
        }

        this.savingData1 = false;
      });
    },
    async saveCard2Items() {
      this.resetCard2Error();
      this.snackbarErrorMessage = null;

      this.card2Error.linkedin = (await this.$refs.linkedin.checkIsValid())
        ? null
        : true;

      this.card2Error.twitter = (await this.$refs.twitter.checkIsValid())
        ? null
        : true;

      this.card2Error.facebook = (await this.$refs.facebook.checkIsValid())
        ? null
        : true;

      this.card2Error.instagram = (await this.$refs.instagram.checkIsValid())
        ? null
        : true;

      this.card2Error.coursera = (await this.$refs.coursera.checkIsValid())
        ? null
        : true;

      if (Object.values(this.card2Error).some(x => x != null)) {
        return;
      }

      this.savingData2 = true;
      this.isEditCard2 = false;

      let saveData = {
        externalLinks: {
          linkedin: this.card2.linkedin,
          twitter: this.card2.twitter,
          facebook: this.card2.facebook,
          instagram: this.card2.instagram,
          coursera: this.card2.coursera,
        },
      };

      this.update(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
        }

        this.savingData2 = false;
      });
    },
    update(data) {
      return updateEmployee({
        input: data,
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
